/* global REMOTE_PAGE_URL, DocumentTouch */
require('../polyfills/classList.js');

const Events = require('../events.js');
const Fields = require('../fields.js');
const Style = require('../style.js');
const Message = require('../message.js');

/* Constructor */

function View() {
  this.type = null;   // string for input type 
  this.$input = null; // the dom object for the input field
  this.empty = true;  // the empty state of the input field
  this.height = null;
  this.$span = null;

  this.$hiddenInput1 = null; // used to capture autofill info
  this.$hiddenInput2 = null;
  
  this.sourcePageUrl = null;
  this.sourcePageOrigin = null;

  this.sourceWindow = null; // message passing. 

  // fix tabstop bug in some browsers
  window.addEventListener('focus', () => {
    if (('ontouchstart' in window) || window.DocumentTouch && document instanceof DocumentTouch) { 
      // Touch events are supported. Don't autofocus the input.
    } else {
      this.$input.focus();
    }
  });
}

/* Render methods */

View.prototype._init = function() {
  var self = this;
  this.type = self._getUrlParameter(window.location.search, 'type');
  this.sourcePageUrl = self._getUrlParameter(window.location.search, 'source');
  this.sourcePageOrigin = self._getUrlParameter(window.location.search, 'origin');

  // If 'tel' is a supported type, we'll use it.
  function checkInput(type) {
    var input = document.createElement('input');
    input.setAttribute('type', type);
    return input.type == type;
  }

  // create element
  var input = document.createElement('input');
  input.id = `bambora-${self.type}`;
  input.type = (checkInput('tel') ? 'tel' : 'text');
  input.autocorrect = 'off';
  input.autocapitalize = 'none';
  input.spellcheck = 'false';

  // autocomplete hints (these values shouldn't be changed)
  if (this.type === Fields.CARD_NUMBER) {		
    input.autocomplete = 'cc-number';
    input.name = 'ccnumber';
    input.setAttribute('aria-label', 'Card number');
    var span = document.createElement('span');
    span.setAttribute('class', 'sr-only');
    // styling
    span.setAttribute('style', 'position: absolute !important; clip: rect(1px, 1px, 1px, 1px); width: 1px !important; height: 1px !important; padding: 0 !important; border: 0 !important; overflow: hidden; white-space: nowrap;');
    this.$span = span;
  } else if (this.type === Fields.CVV) {		
    input.autocomplete = 'cc-csc';		
    input.name = 'cvv2';
    input.setAttribute('aria-label', 'Card security code (CVV)');
  } else if (this.type === Fields.EXPIRY) {		
    input.autocomplete = 'cc-exp';		
    input.name = 'cc-exp';
    input.setAttribute('aria-label', 'Card expiration date (MM/YY)');
  }
  
  // styling
  input.style.boxSizing = 'border-box';
  input.style.width = '100%';
  input.style.height = '100%';
  input.style.border = 'none';
  input.style.overflow = 'visible';
  input.style.backgroundColor = 'transparent';
  
  // add to page
  this.$input = input;
  this.height = document.documentElement.scrollHeight;
  document.body.appendChild(input);
  if(this.$span !== null){
    document.body.appendChild(this.$span);
  }
};

View.prototype.createHiddenInput = function(field) {
  const self = this; 

  let input = document.createElement('input');
  
  input.style.position = 'absolute';
  input.style.top = '-9999px';
  input.style.left = '-9999px';
  input.tabIndex = '-1';
  input.setAttribute('aria-hidden', true);

  if (field === Fields.CARD_NUMBER) {
    input.autocomplete = 'cc-number';
    input.name = 'ccnumber';
    input.id = 'ccnumber';
  } else if (field === Fields.CVV) {
    input.autocomplete = 'cc-csc';
    input.name = 'cvv2';
    input.id = 'cvv2';
  } else if (field === Fields.EXPIRY) {
    input.autocomplete = 'cc-exp';
    input.name = 'cc-exp';
    input.id = 'cc-exp';
  }

  input.addEventListener('change', e => {
    self.postMessage(Message.changeValue(e.target.value, true), field);
  });

  document.body.appendChild(input);
  return input;
};

View.prototype._initAutofillInputs = function() {
  const self = this;

  if (self.type === Fields.CARD_NUMBER) {
    self.$hiddenInput1 = self.createHiddenInput(Fields.CVV);
    self.$hiddenInput2 = self.createHiddenInput(Fields.EXPIRY);
  } else if (self.type === Fields.CVV) {
    self.$hiddenInput1 = self.createHiddenInput(Fields.CARD_NUMBER);
    self.$hiddenInput2 = self.createHiddenInput(Fields.EXPIRY);
  } else if (self.type === Fields.EXPIRY) {
    self.$hiddenInput1 = self.createHiddenInput(Fields.CARD_NUMBER);
    self.$hiddenInput2 = self.createHiddenInput(Fields.CVV);
  }
};

View.prototype._resetAutofillInputs = function() {
  const self = this;
  self.$hiddenInput1.parentNode.removeChild(self.$hiddenInput1);
  self.$hiddenInput2.parentNode.removeChild(self.$hiddenInput2);
  self._initAutofillInputs();
};

// returns the value of the url parameter with given name. Need to pass in
// window.location.search as first argument (keeps function testable).
// TODO: Move this outside of the view so it can be tested. 
View.prototype._getUrlParameter = function(windowLocationSearch, sParam) {
  var sPageURL = decodeURIComponent(windowLocationSearch.substring(1)),
    sURLVariables = sPageURL.split('&'),
    sParameterName,
    i;

  for (i = 0; i < sURLVariables.length; i++) {
    sParameterName = sURLVariables[i].split('=');

    if (sParameterName[0] === sParam) {
      return sParameterName[1] === undefined ? true : sParameterName[1];
    }
  }
};

View.prototype.addStylesForCssClass = function(styles, cssClass) {
  const styleSheet = document.querySelector('#styles').sheet;
  const rules = Style.buildRuleStringFromStyle(styles);

  styleSheet.insertRule(`.${cssClass} { ${rules} }`, 0);

  if (styles[':hover']) {
    const hoverRules = Style.buildRuleStringFromStyle(styles[':hover']);
    styleSheet.insertRule(`.${cssClass}:hover { ${hoverRules} }`, 0);
  }

  if (styles[':focus']) {
    const focusRules = Style.buildRuleStringFromStyle(styles[':focus']);
    styleSheet.insertRule(`.${cssClass}:focus { ${focusRules} }`, 0);
  }
};

View.prototype._addStyles = function(styles) {
  if (styles.base) {
    self.view.addStylesForCssClass(styles.base, 'base');
  }

  if (styles.complete) {
    self.view.addStylesForCssClass(styles.complete, 'complete');
  } 

  if (styles.empty) {
    self.view.addStylesForCssClass(styles.empty, 'empty');
  }

  if (styles.error) {
    self.view.addStylesForCssClass(styles.error, 'error');
  }
};

View.prototype._removeStyles = function() {
  // Reset styles by removing all except for the last pre-existing 
  // rule that is {margin: 0px; padding: 0px;}
  const styleSheet = document.querySelector('#styles').sheet;
  var rules = styleSheet.cssRules;

  var i = rules.length - 1;
  while (i-- && i >= 0) {
    styleSheet.deleteRule(i);
  }
};

View.prototype._addCssClass = function(cssClass) {
  this.$input.classList.add(cssClass);
  this.height = document.documentElement.scrollHeight;
};

View.prototype._removeCssClass = function(cssClass) {
  this.$input.classList.remove(cssClass);
  this.height = document.documentElement.scrollHeight;
};

View.prototype._updatePlaceholder = function(placeholder) {
  this.$input.placeholder = placeholder;
};

View.prototype._updateTextContent = function(content) {
  this.$span.textContent = content;
};

View.prototype._error = function(str) {
  console.error(`Custom Checkout: ${str}`);
};

View.prototype._noOutline = function() {
  this.$input.style.outline = 'none';
};

View.prototype._autofillStyle = function() {
  this.$input.focus();
  this.$input.style.backgroundColor = 'rgb(250, 255, 189)';
  this.$input.style.setProperty('color', 'rgba(30, 30, 30, 1)', 'important');
};

View.prototype._removeAutofillStyle = function() {
  this.$input.style.backgroundColor = null;
  this.$input.style.color = null;
};

/* Render handler */

View.prototype.render = function(viewCmd, parameter) {
  const self = this;
  var viewCommands = {
    init: function() {
      self._init(parameter);
    },
    initAutofillInputs: function() {
      self._initAutofillInputs(parameter);
    },
    resetAutofillInputs: function() {
      self._resetAutofillInputs(parameter);
    },
    updatePlaceholder: function() {
      self._updatePlaceholder(parameter);
    },
    updateTextContent: function() {
      self._updateTextContent(parameter);
    },
    error: function() {
      self._error(parameter);
    },
    addStyles: function() {
      self._addStyles(parameter);
    },
    removeStyles: function() {
      self._removeStyles();
    },
    addCssClass: function() {
      self._addCssClass(parameter);
    },
    removeCssClass: function() {
      self._removeCssClass(parameter);
    },
    autofillStyle: function() {
      self._autofillStyle(parameter);
    },
    removeAutofillStyle: function() {
      self._removeAutofillStyle(parameter);
    },
    noOutline: function() {
      self._noOutline(parameter);
    },
  };

  viewCommands[viewCmd]();
};

View.prototype.postMessage = function(msg, target) {
  const self = this; 

  let encodedMessage;
  try {
    encodedMessage = JSON.stringify(msg);
  }
  catch (err) {
    self.view.render('error', err.message);
    encodedMessage = msg;
  }

  if (target === 'source') {
    self.sourceWindow.postMessage(encodedMessage, self.sourcePageUrl);
  } 
  else {
    const frames = this.sourceWindow.frames;
    var targetFrame;
    for (var i = 0; i < frames.length; i++) {
      var queryString = '';
      try {
        queryString = frames[i].location.search;
      }
      catch (err) {
        // Ignoring potential CORS issues with an iframe.
      }

      if (queryString) {
        let type = self._getUrlParameter(queryString, 'type');
        if (type === target) {
          targetFrame = frames[i];
          break;
        }
      }
    }

    if (targetFrame) {
      targetFrame.postMessage(encodedMessage, REMOTE_PAGE_URL);      
    } 
    else {
      self.render('error', `The ${target} field has not been mounted to the page`);
    }
  }
};

View.prototype.checkForCvv = function() {
  const self = this;
  const frames = this.sourceWindow.frames;

  var cvvFound = false;

  for (var i = 0; i < frames.length; i++) {
    var queryString = '';
    try {
      queryString = frames[i].location.search;
    }
    catch (err) {
      // Ignoring potential CORS issues with an iframe.
    }

    if (queryString) {
      let type = self._getUrlParameter(queryString, 'type');

      if (type === Fields.CVV) {
        cvvFound = true;
        break;
      }
    }
  }

  return cvvFound;
};

View.prototype.focus = function() {
  this.$input.focus();
};

View.prototype.blur = function() {
  this.$input.blur();
};

View.prototype.clear = function() {
  this.$input.value = '';
};

/* Bind callbacks */

View.prototype.bind = function(event, handler) {
  const self = this;
  if (event === 'message') {
    window.addEventListener(event, handler, false);
  } else { // e.g. focus, blur, empty, brand...
    self.$input.addEventListener(event, handler, false);
  }
};

View.prototype.trigger = function(event, data) {
  const self = this;
  
  const domEvent = document.createEvent('Event');
  domEvent.initEvent(event, false, true);
  
  if (event === Events.value) {
    self.$input.value = data;
  } else if (event === Events.brand) {
    self.$input.dispatchEvent(domEvent);
  } else if (event === Events.empty) {
    self.$input.dispatchEvent(domEvent);
  } else if (event === Events.error) {
    self.$input.dispatchEvent(domEvent);
  } else if (event === Events.complete) {
    self.$input.dispatchEvent(domEvent);
  }
};

View.prototype.getCursorPosition = function() {
  const self = this;
  let position;
  if ('selectionEnd' in self.$input) {
    position = self.$input.selectionEnd;
  } else if (document.selection) {
    // IE
    self.$input.focus();
    let sel = document.selection.createRange();
    let selLen = document.selection.createRange().text.length;
    sel.moveStart('character', -self.$input.value.length);
    position = sel.text.length - selLen;
  }
  return position;
};

View.prototype.setCursorPosition = function(position) {
  const self = this;

  // use setTimeout to handle cursor not being moved properly on Samsung's Android keyboards
  setTimeout(function() {
    if (self.$input.setSelectionRange) {
      self.$input.focus();
      self.$input.setSelectionRange(position, position);
    }
    else if (self.$input.createTextRange) {
      let range = self.$input.createTextRange();
      range.collapse(true);
      range.moveEnd('character', position);
      range.moveStart('character', position);
      range.select();
    }
  }, 0);
};

module.exports = View;



// WEBPACK FOOTER //
// ./app/remote/view.js